import React from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Iconfont } from "../../../../../components/icon/iconfont";
import { IMAGE_GEEKO_LTD } from "../../../../../../constants";
import { useRef } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setZoomImagePopover } from "../../../../../../store/actions/pages/product";

const ZoomImagePopover = props =>{
    useStyles(classes);
    const { imagePopover } = props;
    const { image, images } = imagePopover;
	const [ initialSlide, setInitialSlide ] = useState((images||[]).indexOf(image)+1 || 1);
    const disptach = useDispatch();

    const initialOpts = {
		initialSlide:initialSlide-1
	}

    const onClose = () =>{
        disptach(setZoomImagePopover(null));
    }


    return <div className={classes.ZoomImagePopover}>
            <Iconfont className={classes.CloseIcon} onClick={onClose}>&#xe7c9;</Iconfont>

            <span id="image-popover-prev" className={classes.Prev}>
                <Iconfont>&#xe693;</Iconfont>
            </span>

            <div className={classes.ImageContainer}>
                

                <Swiper
                    slidesPerView='auto'
                    navigation={{
                        prevEl: '#image-popover-prev',
                        nextEl: '#image-popover-next',
                        disabledClass:classes.NavigationDisabled
                    }} 
                    onSlideChange={(swiper) => {
                        setInitialSlide(swiper.realIndex + 1)
                    }}
                    onSwiper={(swiper) => {}}
                    {...initialOpts}
                >
                    {
                        images && images.map((image, index) => <SwiperSlide className={classes.ImageSlide} key={index}>
                            <div className={classes.ImageCount}>
                                <span>{initialSlide}</span>/<span>{images?.length}</span>
                            </div>

                            <img src={`${imagePopover?.prefix}/${image}`}/>
                        </SwiperSlide>)
                    }
                </Swiper>
            </div>

            

            <span id="image-popover-next" className={classes.Next}>
                <Iconfont>&#xe694;</Iconfont>
            </span>
        </div>
}

export default ZoomImagePopover;